const default_active_profile = {
  activeProfileType: null,
  id: null,
  name: null
}

const state = {
  isActiveProfileSet: false,
  activeProfile: { ...default_active_profile }
}

const mutations = {
  UPDATE_IS_ACTIVE_PROFILE_SET (state, payload) {
    state.isActiveProfileSet = payload
  },
  UPDATE_ACTIVE_PROFILE_DATA (state) {
    state.activeProfile.activeProfileType = sessionStorage.getItem('activeProfileType')
    state.activeProfile.name = sessionStorage.getItem('activeProfileName')
    state.activeProfile.id = sessionStorage.getItem('activeProfileId')
  },
  RESET_ACTIVE_PROFILE_DATA (state, payload) {
   state.activeProfile = payload
  }
}

const actions = {
  checkSessionStorage ({ commit }) {
    if(sessionStorage.getItem('activeProfile')){
      commit('UPDATE_IS_ACTIVE_PROFILE_SET', true)
    } else {
      commit('UPDATE_IS_ACTIVE_PROFILE_SET', false)
    }
  },
  updateSessionStorage ({ commit }, sessionStorageRequest){
    sessionStorage.setItem('activeProfile', 'true')
    sessionStorage.setItem('activeProfileType', sessionStorageRequest.activeProfileType)
    sessionStorage.setItem('activeProfileId', sessionStorageRequest.id)
    sessionStorage.setItem('activeProfileName', sessionStorageRequest.name)
    commit('UPDATE_IS_ACTIVE_PROFILE_SET', true)
  },
  updateState( {commit} ) {
     commit('UPDATE_ACTIVE_PROFILE_DATA')
  },
  clearSessionStorage ( { commit, dispatch } ) {
    sessionStorage.removeItem('activeProfile')
    sessionStorage.removeItem('activeProfileType')
    sessionStorage.removeItem('activeProfileId')
    sessionStorage.removeItem('activeProfileName')
    commit('UPDATE_IS_ACTIVE_PROFILE_SET', false)
    commit('RESET_ACTIVE_PROFILE_DATA', { ...default_active_profile })
    dispatch('resetOrganizationNumber')
    dispatch('resetUserId')
  },
  resetOrganizationNumber ({ dispatch }) {
    // No payload to be passed so passing null as payload
    dispatch('licenses/resetOrganizationNumber', null, { root: true } )
    dispatch('organizations/resetFilter', null, { root: true })
    dispatch('groups/resetFilter', null, { root: true })
    dispatch('orders/resetFilter', null, { root: true })
  },
  resetUserId ({ dispatch }) {
    // No payload to be passed so passing null as payload
    dispatch('licenses/resetUserId', null, { root: true })
    dispatch('users/resetFilter', null, { root: true })
    dispatch('groups/resetFilter', null, { root: true })
  }
}
const getters = {
  isActiveProfileSet: state => state.isActiveProfileSet,
  activeProfile: state => state.activeProfile,
  hasActiveUser: state => state.isActiveProfileSet && state.activeProfile.activeProfileType === 'user'
}

const sessionStorageModule = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
export default sessionStorageModule